export default __webpack_public_path__ + "static/media/img-3.25a46ad7.jpg";